import React, { useState, useEffect } from "react";
import { Table, Tag, Tooltip, Image, Button, message, Modal } from "antd";
import InspectionApi from "@api/inspectionnew";
import SearchForm from "@components/SearchForm";
import { connect } from "react-redux";
import { getStationData, toolMouseTip } from "@utils/common";
import TaskInfo from "../components/TaskInfo";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import "../style.scss";
const StatusData = ["待巡检", "巡检中", "部分完成", "已完成"];
const colorStatus = ["#FF3819", "#2db7f5", "#24ADF3", "#2465F3"];
const TaskCom = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // 表格数据
  const [leakImageUrlsVisi, setLeakImageUrlsVisi] = useState([]);
  const [detailVisible, setDetailVisible] = useState(false);
  const [detailData, setDetailData] = useState([]);
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    name: "",
  });
  const [total, setTotal] = useState(0);

  // 搜索
  const [inputList] = useState([
    {
      label: "任务组名称:",
      name: "taskGroupName",
      message: "请输入任务组名称",
      span: 8,
      labelCol: 6,
    },
  ]);

  // 设置下拉菜单
  const [selectList, setSelectList] = useState();
  const [stationData, setStationData] = useState();

  useEffect(() => {
    getStationList();
  }, []);
  // 获取厂站列表
  const getStationList = () => {
    let data = getStationData(
      props.userInfo.stationIds ? props.userInfo.stationIds : "-1",
      props.userInfo.stationAliasName,
    );
    setSelectList([
      {
        attr: { allowClear: true },
        label: "厂站:",
        name: "stationId",
        message: "请选择厂站",
        options: data,
        span: 8,
        labelCol: 6,
      },
      {
        attr: { allowClear: true },
        label: "是否提交:",
        name: "status",
        message: "请选择",
        options: [
          {
            title: "否",
            value: 0,
          },
          {
            title: "是",
            value: 1,
          },
        ],
        span: 8,
        labelCol: 6,
      },
      {
        attr: { allowClear: true },
        label: "审批状态:",
        name: "approvalStatus",
        message: "请选择",
        options: [
          {
            title: "审批中",
            value: 1,
          },
          {
            title: "通过",
            value: 2,
          },
          {
            title: "拒绝",
            value: 3,
          },
        ],
        span: 8,
        labelCol: 6,
      },
      {
        attr: { allowClear: true },
        label: "任务状态:",
        name: "taskStatus",
        message: "请选择任务状态",
        options: [
          {
            title: "待巡检",
            value: 0,
          },
          {
            title: "巡检中",
            value: 1,
          },
          {
            title: "部分完成",
            value: 2,
          },
          {
            title: "已完成",
            value: 3,
          },
        ],
        span: 8,
        labelCol: 6,
      },
    ]);
    setStationData(data);
  };

  useEffect(() => {
    getListByPages();
  }, [searchParams]);

  const getListByPages = () => {
    setLoading(true);
    InspectionApi.patrolTaskLeakLs(searchParams).then((res) => {
      setLoading(false);
      if (res.status == 0 && res.data) {
        const imgVisib = [];
        res.data.data.forEach((item) => {
          imgVisib.push(false);
        });
        res.data.data.map((item, index) => (item.idx = index));
        setLeakImageUrlsVisi([...imgVisib]);
        setData(res.data.data || []);
        setTotal(res.data.total);
      }
    });
  };

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
    };
    setSearchParams(params);
  };

  // 详情
  const getInfo = (id) => {
    InspectionApi.getPatrolTaskInfo({ id: id - 0 }).then((res) => {
      if (res.status !== "0") return;
      setDetailVisible(true);
      setDetailData(res.data);
    });
  };

  const deleteTask = (id) => {
    Modal.confirm({
      onOk: () => {
        InspectionApi.deleteLeakTaskGroup({ id }).then((res) => {
          if (res.status !== "0") return;
          message.success("删除成功");
          getListByPages();
        });
      },
      title: "请确认",
      icon: <ExclamationCircleOutlined />,
      content: "是否删除",
      okText: "确认",
      cancelText: "取消",
    });
  };

  const columns = [
    {
      title: "任务名称",
      dataIndex: "taskGroupName",
      align: "center",
      key: "taskGroupName",
      render: (_t) => toolMouseTip(_t, 10),
    },
    {
      title: "是否提交说明",
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (_t) =>
        _t ? (
          <Tag color="#87d068">已提交</Tag>
        ) : (
          <Tag color="#BDBDBD">未提交</Tag>
        ),
    },
    {
      title: "审批状态",
      dataIndex: "approvalStatus",
      align: "center",
      key: "approvalStatus",
      render: (val) => {
        if (val == 1) {
          return <Tag color="#2D99FF">审批中</Tag>;
        } else if (val == 2) {
          return <Tag color="#87d068">通过</Tag>;
        } else if (val == 3) {
          return <Tag color="#FF3819">拒绝</Tag>;
        } else {
          return "-";
        }
      },
    },
    {
      title: "巡检状态",
      dataIndex: "taskStatus",
      align: "center",
      key: "taskStatus",
      render: (_t) => <Tag color={colorStatus[_t]}>{StatusData[_t]}</Tag>,
    },
    {
      title: "漏检提交人",
      dataIndex: "handleUserName",
      align: "center",
      key: "handleUserName",
    },
    {
      title: "漏检说明",
      dataIndex: "leakDesc",
      align: "center",
      key: "leakDesc",
    },
    {
      title: "漏检图片",
      dataIndex: "leakImageUrls",
      align: "center",
      key: "leakImageUrls",
      render: (_t, record) => {
        {
          return _t && _t.length > 0 ? (
            <div className="defect-detail-item-imglist">
              <Image
                preview={{
                  visible: false,
                }}
                width={100}
                src={_t[0]}
                onClick={() => {
                  let p = leakImageUrlsVisi;
                  p[record.idx] = true;
                  setLeakImageUrlsVisi([...p]);
                }}
              />

              <div style={{ display: "none" }}>
                <Image.PreviewGroup
                  preview={{
                    visible: leakImageUrlsVisi[record.idx],
                    onVisibleChange: (vis) => {
                      let p = leakImageUrlsVisi;
                      p[record.idx] = vis;
                      setLeakImageUrlsVisi([...p]);
                    },
                  }}
                >
                  {_t.map((item, index) => {
                    return <Image src={item} key={index} />;
                  })}
                </Image.PreviewGroup>
              </div>
            </div>
          ) : (
            "暂无图片"
          );
        }
      },
    },
    {
      title: "开始时间",
      dataIndex: "beginTime",
      align: "center",
      key: "beginTime",
    },
    {
      title: "操作",
      key: "operation",
      render: (_, record) => {
        return (
          <>
            {props.userInfo.btnResources.indexOf(
              "patrol:taskGroup:deleteLeakTaskGroup",
            ) !== -1 && (
              <Button
                onClick={() => deleteTask(record.taskGroupId)}
                size="small"
                type="primary"
                danger
              >
                删除
              </Button>
            )}

            {props.userInfo.btnResources.indexOf("patrol:taskGroup:info") !==
              -1 && (
              <Button
                onClick={() => getInfo(record.taskGroupId)}
                style={{ marginLeft: "5px" }}
                size="small"
                type="primary"
              >
                详情
              </Button>
            )}
          </>
        );
      },
    },
  ];
  return (
    <div className="baseContent boundary">
      <div className="title">
        <div style={{ marginLeft: "24px" }}>
          <SearchForm
            inputList={inputList}
            searchParams={searchParams}
            span={6}
            selectList={selectList}
            onSearch={search}
          />
        </div>
        <div>
          <Table
            className="Table"
            columns={columns}
            dataSource={data}
            rowKey={(record) => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: (total) => `共${total}条数据`,
              total: total,
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>
      </div>
      <TaskInfo
        detailData={detailData}
        visible={detailVisible}
        cancel={() => setDetailVisible(false)}
      ></TaskInfo>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(TaskCom);
